module.exports = __webpack_public_path__ + "static/media/Mothers Honor Roll.826168a4.png";